import * as actionTypes from "./actionTypes";
import { apiStart, apiFail, apiComplete } from "./api";
import axiosBackEnd from "../../config/axios/axios-back-end";
import { message } from "antd";

export const setUser = (authUser) => {
  return {
    type: actionTypes.SETUSER,
    authUser: authUser,
  };
};

export const setToken = (token) => {
  return {
    type: actionTypes.SET_TOKEN,
    token: token,
  };
};

export const getUser = (id, loading = false) => {
  return async (dispatch) => {
    if (loading) {
      dispatch(apiStart());
    }
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.get(`/api/users/getuser/${id}`, null, {
        headers: headers,
      });
      if (loading) {
        dispatch(apiComplete());
      }
      return response.data && response.data.user ? response.data.user : null;
    } catch (err) {
      if (loading) {
        dispatch(apiFail());
        message.error(err.message);
      }
      return null;
    }
  };
};

export const getUserHotels = (loading=false)=>{
  return async(dispatch)=>{
    if(loading){
      dispatch(apiStart());
    }
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const response = await axiosBackEnd.get("/api/hotels/list", {
        params: null,
        headers: headers,
      });
      if (response && response.data) {
        if (response.data.data) {
          return response.data.data;
        }
      }
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        return;
      } else {
        message.error(err.message);
        console.log("Eroor: ", err);
        return;
      }
    } finally{
      if(loading){
        dispatch(apiComplete());
      }
    }
  }
}

export const userCheckUserNameAvailable = (data,loading = true) => {
  return async (dispatch) => {
    if (loading) {
      dispatch(apiStart());
    }
    try {
      const response = await axiosBackEnd.post(
        "/api/users/valid-username",
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return {
        alreadyExist: response.data?.error,
        error:false,
        message: response.data?.message
      }
    } catch (err) {
      console.log(err);
      return {
        alreadyExist: false,
        error: true,
      }
    } finally {
      if (loading) {
        dispatch(apiComplete());
      }
    }
  };
};
